import React from 'react';
const testimonials = [{
  initials: 'LP',
  name: 'Laura P.',
  location: '📍 Buenos Aires | Estimuladora Temprana en Gabinete Privado',
  quote: '"Compré un domingo a la noche. El lunes entré a la sesión de las 9 con el plan exacto. Las 24 sesiones del Tomo 1 son exactamente lo que necesitaba para mis bebés de 0 a 6 meses. Nunca más improviso."'
}, {
  initials: 'MC',
  name: 'Mariela C.',
  location: '📍 Rosario | Estimuladora Temprana — Centro de Desarrollo Infantil',
  quote: '"El semáforo de alertas del Tomo 4 me cambió todo. La primera semana detecté 2 señales que antes hubiera dejado pasar. Pude hablar con las familias con seguridad real y acompañar a tiempo."'
}, {
  initials: 'SV',
  name: 'Sofía V.',
  location: '📍 Córdoba | Estimuladora Temprana Independiente',
  quote: '"Los checklists son únicos en el mercado. Antes tardaba 1 hora en armar un informe para los padres. Ahora abro el PDF, completo 3 casilleros y en 5 minutos tengo el reporte listo para entregar."'
}, {
  initials: 'FL',
  name: 'Florencia L.',
  location: '📍 Tucumán | Estimuladora Temprana en Clínica Pediátrica',
  quote: '"Los guiones para familias del Bono 2 eliminaron las discusiones en el cierre de sesión. Ahora las mamás entienden el plan, hacen la tarea en casa y los nenes progresan el doble de rápido. El sistema funciona."'
}, {
  initials: 'AR',
  name: 'Ana R.',
  location: '📍 Mendoza | Estimuladora Temprana y Docente',
  quote: '"Mi tasa de adherencia pasó del 40% al 80%. Sin cambiar lo que hago. Solo aplicando los scripts de WhatsApp del Bono 2 y el sistema de seguimiento semanal. En 3 meses llené todos mis horarios."'
}, {
  initials: 'VT',
  name: 'Valeria T.',
  location: '📍 Santa Fe | Estimuladora Temprana en Gabinete Interdisciplinario',
  quote: '"Ahora entrego el Consentimiento Informado en la primera entrevista y uso el sistema de abono desde el mes 1. Las familias lo aceptaron todas sin problemas. Este mes cobré el 100% antes del día 5. Primera vez en mi vida."'
}, {
  initials: 'GR',
  name: 'Gabriela R.',
  location: '📍 Salta | Estimuladora Temprana Independiente',
  quote: '"El Manual de Situaciones Difíciles del Bono 6 me salvó la semana más complicada del año. Tuve 3 sesiones seguidas con niños desregulados y familias ansiosas. Con el protocolo de 3 pasos manejé todo sin perder el hilo."'
}];
export function Testimonials() {
  return <section className="w-full px-4 py-10 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(248, 250, 252)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-494">
      <div className="mx-auto max-w-4xl" data-id="element-495">

        {/* Heading */}
        <h2 className="text-3xl font-black text-center leading-10 text-gray-900 m-0 mb-2" data-id="element-496">
          Lo que dicen las profesionales que ya lo usan:
        </h2>
        <p className="text-center text-sm text-gray-600 m-0 mb-8" data-id="element-497">
          +300 profesionales ya transformaron su práctica con este sistema.
        </p>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-498">
          {testimonials.map((t, i) => <div key={i} className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 flex flex-col gap-3" data-id="element-499">
              <div className="flex items-center gap-3" data-id="element-500">
                <div className="w-10 h-10 rounded-full bg-teal-600 text-white flex items-center justify-center font-bold text-sm shrink-0" data-id="element-501">
                  {t.initials}
                </div>
                <div data-id="element-502">
                  <p className="font-bold text-gray-900 m-0 text-sm" data-id="element-503">
                    {t.name}
                  </p>
                  <p className="text-gray-500 m-0 text-xs" data-id="element-504">{t.location}</p>
                </div>
              </div>
              <p className="text-gray-700 m-0 text-sm italic leading-relaxed" data-id="element-505">
                {t.quote}
              </p>
            </div>)}
        </div>

      </div>
    </section>;
}